import { getTransport } from '@core/redux/transport';
import {
  iprelabelApiV1 as prelabelApi,
  iprelabelClientApiV1 as prelabelClientApi,
  iprelabelProcessorClientApiV1 as prelabelProcessorClientApi,
} from '@deepup/internal-apis';

export const fetchScanPrelabel = async (scanId: string): Promise<prelabelApi.PrelabelInfo> => {
  const transport = getTransport();
  const client = new prelabelClientApi.InternalPrelabelServiceClient(transport);

  const response = await client.getLatestPrelabelInfo({
    scanId,
    type: prelabelApi.PrelabelType.UNSPECIFIED,
  }).response;

  return response;
};

export const ingestScanPrelabel = async (
  scanId: string,
  excludedTypes: string[] = [],
): Promise<void> => {
  const transport = getTransport();
  const client = new prelabelProcessorClientApi.InternalPrelabelProcessorServiceClient(transport);

  await client.ingestLatestPrelabel({
    scanId,
    excludedTypes,
  }).response;
};
